<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="offres?.offreBasse"
    [label]="step5.getoffrebasse" [type]="'number'" [rule]="'digits_2'" [name]="getUid() + '_SepAtt_offreBasse'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="offres?.offreElevee"
    [label]="step5.getoffreelevee" [type]="'number'" [rule]="'digits_2'" [name]="getUid() + '_SepAtt_offreElevee'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="offres?.devise" [label]="step5.getdevise"
[type]="'autocomplete'" 
[autoCompleteType]="'DEVISE'"
[autoCompleteTypeIndex]="0"
[rule]="'pattern_13'"
[errorMessage]="{}"
[name]="getUid() + '_SepAtt_devise'">
</app-form-input>
